import { getRoot, IStateTreeNode } from 'mobx-state-tree';
import { FIRST_NUMERIC_URL_PARAMETER_REGEX } from '.';
import { Store } from '../models';
import { WorkspaceAcl } from '../models/Workspace/WorkspaceAcl';

const getWorkspaceAliasFromUrl = (): string | undefined => {
    if (typeof window !== 'undefined') {
        const match = window.location.pathname.match(
            FIRST_NUMERIC_URL_PARAMETER_REGEX
        );
        return match ? match[1] : undefined;
    }
};

const queryWorkspaceAcl = (
    self: IStateTreeNode,
    propertyAccess: (workspaceAcl: WorkspaceAcl) => boolean,
    agentId?: number
): boolean => {
    const store = getRoot<Store>(self);
    if (!store.workspace.workspaceAcl) {
        return false;
    }
    return (
        propertyAccess(store.workspace.workspaceAcl) ||
        agentId === store.account.account?.id
    );
};

export { getWorkspaceAliasFromUrl, queryWorkspaceAcl };
